import { Card } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

export const InspectionCard = ({ title, detail, imgSrc, className='', width }) => {
  const widthStyle = width ? width : "max-w-[188px] w-[188px]"
  return (
    <Card
      horizontal
      className={`w-[23%] ${className}`}
      theme={tenkenTheme.card}
      renderImage={() => (
        <img
          className="h-[80px] lg:px-4 py-4 order-last flex-shrink-0"
          src={imgSrc}
          alt="Page Edit Icon"
        />
      )}
    >
      <div>
        <p className={`truncate  ${widthStyle}`} title={detail}>{title}</p>
        <p className={`font-bold truncate ${widthStyle}`} title={detail}>{detail}</p>
      </div>
    </Card>
  );
};
